<template>
    <a-modal
            :title='titles'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @cancel="onClose"
    >
        <a-spin :spinning="spinning"></a-spin>
        <div class="seachList" v-if="template_code_show == 1">
            <span class="name" >模板编号<span class="red">*</span>：</span>
<!--            <a-select-->
<!--                class="seachs"-->
<!--                v-model="template_code"-->
<!--                placeholder="请选择"-->
<!--                show-search-->
<!--                :filter-option="false"-->
<!--                :not-found-content="templateFetching ? undefined : null"-->
<!--                @search="handleTemplateSearch"-->
<!--                @change="handleTemplateChange"-->
<!--            >-->
<!--                <a-spin v-if="templateFetching" slot="notFoundContent" size="small" />-->
<!--                <a-select-option v-for="item in templateList" :value="item.id" :key="item.id">-->
<!--                    {{ item.code }}-->
<!--                </a-select-option>-->
<!--            </a-select>-->

          <a-input class="seachs"
              disabled=""
              v-model="template_code"
          />
        </div>
        <div class="seachList"><span class="name" v-if="importType==4">分类选择：</span>
            <a-select style="margin-right: 20px" v-model="classId" class="seachs" allowClear :placeholder="'请选择'" v-if="importType==4">
                <a-select-option :value="item.id" :key="index" v-for="(item,index) in classList">
                    {{item.name}}
                </a-select-option>
            </a-select>
            <span class="name" >导入类型：</span>
            <a-select v-model="type" class="seachs" allowClear :placeholder="'请选择'">
                <a-select-option :value="item.id" :key="index" v-for="(item,index) in importTypeList">
                    {{item.name}}
                </a-select-option>
            </a-select>
        </div>
        <div class="seachList" v-if="image_method_show == 1">
            <span class="name" >图片处理：</span>
            <a-radio-group v-model="image_method">
                <a-radio :value="1"> 平铺</a-radio>
                <a-radio :value="2"> 留白</a-radio>
            </a-radio-group>
        </div>
        <div class="seachList">
        </div>
        <a-upload-dragger
            v-if="[1,2,3,4,5,6,7,18].indexOf(this.importType)>-1"
                name="file"
                :beforeUpload="handleBeforeUpload"
                :remove="removeChange"
                :fileList="fileList"
                @drop="handleDrop"
        >
            <p class="ant-upload-drag-icon">
                <a-icon style="color: #0260F8" type="cloud-upload" />
            </p>
            <p class="">将文件拖拽到此区域，或 <span style="color: #0260F8">点击添加</span></p>
        </a-upload-dragger>
        <!-- 文件夹上传 -->
        <template v-else>
            <a-upload-dragger
                name="file"
                :beforeUpload="handleBeforeUploadDirectory"
                :fileList="fileDirList"
                directory
            >
                <p class="ant-upload-drag-icon">
                    <a-icon style="color: #0260F8" type="cloud-upload" />
                </p>
                <p class="">将文件拖拽到此区域，或 <span style="color: #0260F8">点击添加</span></p>
            </a-upload-dragger>
            <div class="ant-upload-list ant-upload-list-text" v-for="file in fileDirList" :key="file">
                <div class="">
                    <span>
                        <div class="ant-upload-list-item ant-upload-list-item-undefined ant-upload-list-item-list-type-text">
                            <div class="ant-upload-list-item-info">
                                <span>
                                    <i aria-label="图标: paper-clip" class="anticon anticon-paper-clip"><svg viewBox="64 64 896 896" data-icon="paper-clip" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"></path></svg></i>
                                    <span :title="file.name" class="ant-upload-list-item-name">{{file.name}}</span>
                                    <span class="ant-upload-list-item-card-actions " @click="()=>{
                                        fileList = []
                                        fileDirList = []
                                    }"><a title="删除文件"><i aria-label="图标: delete" tabindex="-1" class="anticon anticon-delete" title="删除文件"><svg viewBox="64 64 896 896" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path></svg></i></a></span>
                                </span>
                            </div>
                        </div>
                    </span>
        </div>
      </div>
    </template>
    <div class="tip">
      <div class="left">
        友情提示：
      </div>
      <div class="right">
        <div v-if="importType==5||importType==4">
          <p>1、导入的文档格式必须为“zip”或“rar”格式，其余格式暂不支持导入;</p>
          <p>2、导入的文档大小不超过100M，超出后会导致失败；</p>
        </div>
        <div v-else-if="[8,9,10,11,12,13].indexOf(importType)>-1">
          <p>1、导入的文件格式必须文件夹格式，其余格式暂不支持导入;</p>
          <p v-if="importType==8||importType==11">2、导入的文件大小不超过1G ，超出后会导致失败；</p>
          <p v-if="importType==9||importType==10">2、导入的文件大小不超过100M，超出后会导致失败；</p>
          <p v-if="importType==12">2、导入的文件大小不超过10M，超出后会导致失败；</p>
          <p v-if="importType==13">2、导入的文件大小不超过3G，超出后会导致失败；</p>
        </div>
        <div v-else-if="importType==18">
          <p>1、导入的文件格式必须.xsl/.xslx格式，其余格式暂不支持导入;</p>
          <p>2、导入的文件大小不超过100M，超出后会导致失败；</p>
        </div>
        <div v-else>
          <p>1、导入的文档格式必须为“xls”或“xlsx”格式，其余格式暂不支持导入;</p>
          <p>2、导入的文档大小不超过2M，超出后会导致失败；</p>
        </div>
        <p v-if="importType!=5">3、文档格式模版， <span style="color: #0260f8;cursor:pointer" @click="downLoad">点击下载；</span> </p>
      </div>
    </div>
    <template #footer >
      <a-button key="back" @click="onSubmit" type="primary">确定</a-button>
      <a-button key="submit" @click="onClose">取消</a-button>
    </template>
  </a-modal>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    import axiosUpload from 'axios';
    import axios from 'axios';
    export default {
        components:{},
        props: ["visible","importType","dataList","product_ids",'templateCode'],
        name: "importModel",
        data(){
            return {
                drawerConfig,
                titles:'',
                type:1,
                fileList:[],
                classId:'',
                classList:[],
                importTypeList:[],
                template_code: undefined, // 模板code
                templateList: [], // 模板列表
                templateFetching: false, // 模板列表加载中
                unique: '', // 唯一标识
                uploadDirSize: 0, // 文件大小
                uploadDirStatus: false,
                template_code_show: 1, // 0不展示 1展示
                fileDirList: [], // 文件夹列表
                spinning: false,
                image_method: 1, // 1 平铺  2留白  默认选择“平铺”
                image_method_show: '', // 0 不需要图片方式 1需要
            }
        },
        mounted(){
            this.$message.config({
                top: `24px`,
                duration: 2,
                maxCount: 1,
            });
            console.log(this.importType,'importType')
            console.log(this.dataList,'dataList')
            this.template_code=this.templateCode
            if(this.importType == 5||this.importType == 3){
                this.importTypeList.push(this.dataList.methods[0])
                // this.dataList.methods.splice(1,1)
                console.log(this.dataList.methods)
                // this.dataList.methods = this.dataList.methods
            }else if(this.importType == 18) {
              this.importTypeList = [{id: 1, name: "批量导入seo",}]
            }else{
                this.importTypeList = this.dataList.methods
            }
            this.dataList.types.forEach((item,index)=>{
                if(item.id==this.importType){
                    this.titles = `导入${item.name}`
                    this.template_code_show = item.template_code
                    this.image_method_show = item.image_method
                }
            })
            if(this.importType == 4){
                let data = {
                    id:this.product_ids
                }
                API.service.GET_CLASS(data).then(res=>{
                    console.log(res)
                    this.classList = res.data.data
                })
            }
            API.service.GET_TEMPLATE({
                type: this.importType
            }).then(res=>{
                this.templateList = res.data.data
            })
        },
        methods:{
            handleTemplateSearch(code){
                if(!code) {
                    return false
                }
                API.service.GET_TEMPLATE({
                    code: code
                }).then(res=>{
                    console.log(res)
                    this.templateList = res.data.data
                })
            },
            handleTemplateChange(data){
                this.template_code = data
            },
            removeChange(){
                this.fileList = []
            },

            handleBeforeUpload(file) {
                // 在这里保存文件到 fileList，但不开始上传
                // 1联系方式、2社交链接、3产品分类、4下载、5证书、6视频、7FAQ
                let fileReg; // 文件格式正则
                let maxSize;
                if(this.importType == 4 || this.importType == 5){
                    fileReg = /^.+(\.rar|\.zip)$/
                    maxSize = 100
                }else if(this.importType == 18){
                  fileReg = /^.+(\.xls|\.xlsx)$/
                  maxSize = 100
                } else {
                    fileReg = /^.+(\.xls|\.xlsx)$/
                    maxSize = 2
                }
                if (!fileReg.test(file.name)) {
                    if(this.importType == 1 || this.importType == 2 || this.importType == 3 || this.importType == 6 || this.importType == 7){
                        this.$message.warning('文档格式必须为“.xls”或“.xlsx”格式!');
                    }
                    if(this.importType == 4 || this.importType == 5){
                        this.$message.warning('文件格式必须为“.rar或“.zip”格式!');
                    }
                } else if (file.size > maxSize * 1024 * 1024) {
                    this.$message.warning(`文件大小不能超过${maxSize}M！`);
                } else {
                    this.fileList = []
                    this.fileList.push(file);
                }
                return false; // 返回 false 以阻止自动上传
            },
            handleBeforeUploadDirectory(file) {
              console.log("789789file",file)
                // 8、产品 9、新闻 10、案例 11、单页  12、在线客服 13、全部
                let folderPath = ''
                if(!this.uploadDirStatus) {
                    this.fileDirList = []; // 清空文件列表
                    this.fileList = []; // 清空文件列表
                    this.uploadDirSize = 0;
                    this.uploadDirStatus = true;
                }
                setInterval(() => {
                    this.uploadDirStatus = false;
                }, 300)
                this.uploadDirSize =  this.uploadDirSize + (file.size || 0);

                let maxSize;
                if (this.importType == 8 || this.importType == 11) {
                    maxSize = 1  // G
                }
                if (this.importType == 9 || this.importType == 10) {
                    maxSize = 100
                }
                if (this.importType == 12) {
                    maxSize = 10
                }
                if (this.importType == 13) {
                    maxSize = 3  // G
                }

                if ([9,10,12].indexOf(this.importType)>-1 && file.size > maxSize * 1024 * 1024) {
                    this.$message.warning(`文件夹大小不超过${maxSize}M！`);
                } else if ([8,11,13].indexOf(this.importType)>-1 && file.size > maxSize * 1024 * 1024 * 1024) {
                    this.$message.warning(`文件夹大小不超过${maxSize}G！`);
                } else {
                  if (file.name.startsWith("~$")) {
                    console.log("字符串以 ~$ 开头");
                  } else {
                    this.fileList.push(file);
                    this.fileDirList = [{
                      name: file.webkitRelativePath.split('/')[0]
                    }]
                  }

                }
                return false;
            },
            removeDirectoryChange(file){
                this.fileList = this.fileList.filter((item) => item.uid !== file.uid); // 根据 UID 删除文件
            },
            onClose(){
                this.type = 1
                this.fileList = []
                this.$emit("changVisible", false);
            },
            downLoad(){
                console.log(this.$store.state)
                let data = {
                    type:this.importType
                }
                API.service.GET_LOAD(data).then(res=>{
                    window.open(res.data.data.file)
                })
            },
            uploadDir(){
                if(this.fileList.length == 0){
                    this.$message.destroy()
                    return this.$message.warning(`请上传文件！`);
                }
                this.spinning = true
                API.service.GET_UNIQUE({}).then(res=>{
                    this.unique = res.data.data.unique
                    this.importDir()
                })
            },
            importDir(){
                let uploadNum = 0
                this.fileList.forEach((file, index) => {
                    let data = new FormData()
                    data.append('file',file)
                    data.append('unique',this.unique)
                    data.append('relative_path',file.webkitRelativePath)
                    let apiUrl = '/batch/FileLib/importDir'
                    axios.post(this.$store.state.urlExper+apiUrl, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization:  window.sessionStorage.getItem('signature'),
                        }
                    }).then(res => {
                        // 处理上传成功的响应
                        if(res.data.code==1){
                            uploadNum++
                            if(uploadNum == this.fileList.length){
                                this.uploadDicSuccess(res.data.data.path)
                            }
                        } else {
                            this.spinning = false
                        }
                    })
                })
            },
            uploadDicSuccess(path){
                API.service.IMPORT_CONFIRM({
                    id: this.product_ids,
                    type: this.importType,
                    method: this.type,
                    template_code: this.template_code,
                    path: path,
                    image_method: this.image_method
                }).then(res=>{
                    this.spinning = false
                    if(res.data.code==200){
                        this.$message.success(res.data.msg);
                        this.type = 1
                        this.fileList = []
                        this.$emit("changVisible", false);
                    }else{
                        this.$message.warning(res.data.msg);
                    }
                })
            },
            onSubmit(){
                if(!this.template_code && this.template_code_show == 1) {
                    this.$message.destroy()
                    this.$message.warning("请选择模板编号");
                    return
                }
                if([8,9,10,11,12,13].indexOf(this.importType)>-1){
                    this.uploadDir()
                    return false
                }
                this.spinning = true
                let data = new FormData()
                data.append('id',this.product_ids)
                data.append('type',this.importType)
                data.append('method',this.type)
                data.append('template_code',this.template_code)
                if(this.importType==4){
                data.append('cate_id',this.classId)
                }
                data.append('file',this.fileList[0])
                axios.post(this.$store.state.urlExper+'/batch/fileLib/import', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization:  window.sessionStorage.getItem('signature'),
                    }
                }).then(res => {
                    // 处理上传成功的响应
                    console.log(res.data)
                    this.spinning = false
                    if(res.data.code==200){
                        this.$message.success(res.data.msg);
                        this.type = 1
                        this.fileList = []
                        this.$emit("changVisible", false);
                    }else{
                        this.$message.warning(res.data.msg);
                    }
                })
            },
        },
        watch:{
            importType:function(a,b){
    },
  }
}
</script>

<style scoped>
     .seachs {
        width: 160px;
    }
    .seachList{
        margin-bottom: 20px;
    }
    .tip{
        display: flex;
        margin-top: 20px;
    }
    .seachList .name {
        display: inline-block;
        min-width: 76px;
    }
    .red {
        color: red;
    }
    .ant-spin-spinning {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.6);
    }
</style>